import { render, staticRenderFns } from "./NameDialog.vue?vue&type=template&id=35af303f&scoped=true&"
import script from "./NameDialog.vue?vue&type=script&lang=js&"
export * from "./NameDialog.vue?vue&type=script&lang=js&"
import style0 from "./NameDialog.vue?vue&type=style&index=0&id=35af303f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af303f",
  null
  
)

export default component.exports